import { ManagedHomeSections } from "@/components/pages/ManagedPage";
import { CASE_STUDIES_ENABLED } from "@/config/features";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import BusinessResultStrip from "@/components/beedigit/BusinessResultStrip";
import CustomerLogos from "@/components/beedigit/CustomerLogos";
import {
  ContinuousImprovementFoundation,
  LeanWasteTable,
  DataToKaizenFlow,
  LeanSixSigmaToolkit,
  OpExTeamsRoles,
  LeanKPIDashboards,
  DailyManagementSystem,
  SixSigmaDMAIC,
  TPMSupport,
  StandardWorkDigital5S,
  LeanFinalCTA,
} from "@/components/beedigit/LeanSections";
import ProblemGap from "@/components/beedigit/ProblemGap";
import SolutionOverview from "@/components/beedigit/SolutionOverview";
import MarketPositioning from "@/components/beedigit/MarketPositioning";
import StartSmallScaleBig from "@/components/beedigit/StartSmallScaleBig";
import IndustryTemplates from "@/components/beedigit/IndustryTemplates";
import IndustryProcessPreview from "@/components/beedigit/IndustryProcessPreview";
import ModulesGrid from "@/components/beedigit/ModulesGrid";
import HardwareBlock from "@/components/beedigit/HardwareBlock";
import IntegrationsBlock from "@/components/beedigit/IntegrationsBlock";
import BusinessOutcomes from "@/components/beedigit/BusinessOutcomes";
import OnboardingTimeline from "@/components/beedigit/OnboardingTimeline";
import SecurityEnterprise from "@/components/beedigit/SecurityEnterprise";
import CaseStudiesPreview from "@/components/beedigit/CaseStudiesPreview";
import RoleBasedValue from "@/components/beedigit/RoleBasedValue";
import HomeFAQ from "@/components/beedigit/HomeFAQ";
import { useHomeFaqs } from "@/hooks/useCatalog";

const HomeFaqJsonLd = () => {
  const { items } = useHomeFaqs();
  return items.length ? <FAQJsonLd items={items.map((f) => ({ question: f.q, answer: f.a }))} /> : null;
};
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import SEO, { OrganizationJsonLd, FAQJsonLd } from "@/components/SEO";

const Index = () => (
  <div className="min-h-screen">
    <SEO
      title="Plug & Play MES & OEE Platform"
      description="Plug & Play MES, OEE and IIoT platform that helps manufacturers increase output, reduce downtime and run Lean improvement with real-time shop-floor data."
    />
    <OrganizationJsonLd />
    <HomeFaqJsonLd />

    <Navigation />
    <main>
      <ManagedHomeSections />
    </main>
    <Footer />
  </div>
);

export default Index;
